export default "__VITE_ASSET__BABhPJXE__"